import { type Context, useContext } from 'react';

import { AdDataContext } from '../shared/context';
import type { AdData, AdDataContextValue, ConfigName } from '../types';

export function useAdDataContext<T>(
  name: ConfigName,
  context: Context<AdDataContextValue<T>>,
): AdData<T> {
  const adContext = useContext(AdDataContext);
  const dataContext = useContext(context);

  if (adContext && !dataContext?.data?.data) {
    adContext?.operations?.setData[name](true);
  }

  if (dataContext?.data) {
    return dataContext.data;
  }

  return {
    loading: true,
    data: undefined,
    error: undefined,
  };
}
